export default "__VITE_ASSET__BUCktz2x__"